export default __webpack_public_path__ + "static/media/aircraft_plant_2.0f0907b6.png";